(function () {
    var gate = document.querySelector('[data-age-gate]');

    if (!gate) return;

    var root = document.documentElement;
    var body = document.body;
    var dialog = gate.querySelector('.age-gate__dialog');
    var acceptButton = gate.querySelector('[data-age-gate-accept]');
    var denyButton = gate.querySelector('[data-age-gate-deny]');
    var status = gate.querySelector('[data-age-gate-status]');
    var rememberDays = parseInt(gate.dataset.rememberDays, 10) || 30;
    var storageKey = gate.dataset.storageKey || 'shopify-age-gate';
    var underageMessage = gate.dataset.underageMessage || '';
    var underageUrl = gate.dataset.underageUrl || '';
    var selectors = [
        'a[href*="/checkout"]',
        '[name="checkout"]',
        '.button-checkout',
        '.link-checkout'
    ].join(',');

    function readState() {
        try {
            var raw = localStorage.getItem(storageKey);

            if (!raw) return null;

            var parsed = JSON.parse(raw);
            var expiresAt = Number(parsed && parsed.expiresAt);

            if (parsed.status !== 'verified' || !expiresAt || Date.now() > expiresAt) {
                localStorage.removeItem(storageKey);
                return null;
            }

            return parsed;
        } catch (error) {
            return null;
        }
    }

    function lockGate() {
        root.classList.add('age-gate-pending');
        body.classList.add('age-gate-locked');
        gate.hidden = false;
        gate.setAttribute('aria-hidden', 'false');

        window.requestAnimationFrame(function () {
            dialog.focus();
        });
    }

    function unlockGate() {
        root.classList.remove('age-gate-pending');
        body.classList.remove('age-gate-locked');
        gate.setAttribute('aria-hidden', 'true');
        gate.hidden = true;
    }

    function saveApproval() {
        var expiresAt = Date.now() + (rememberDays * 24 * 60 * 60 * 1000);

        try {
            localStorage.setItem(storageKey, JSON.stringify({
                status: 'verified',
                expiresAt: expiresAt
            }));
        } catch (error) {
            // Ignore storage failures and continue for the current page view.
        }
    }

    function showBlockedState() {
        if (status) {
            status.textContent = underageMessage;
        }

        lockGate();

        if (underageUrl) {
            window.setTimeout(function () {
                window.location.assign(underageUrl);
            }, 1200);
        }
    }

    if (readState()) {
        unlockGate();
    } else {
        lockGate();
    }

    acceptButton.addEventListener('click', function () {
        saveApproval();

        if (status) {
            status.textContent = '';
        }

        unlockGate();
    });

    denyButton.addEventListener('click', function () {
        showBlockedState();
    });

    document.addEventListener('click', function (event) {
        if (readState()) return;

        var trigger = event.target.closest(selectors);

        if (!trigger) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        lockGate();
    }, true);

    document.addEventListener('submit', function (event) {
        if (readState()) return;

        var submitter = event.submitter;

        if (!submitter) return;

        if (submitter.name !== 'checkout' && !submitter.classList.contains('button-checkout')) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        lockGate();
    }, true);
})();
